/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useRegistrationView, RegisterationProvider} from './core/RegisterationProvider'

const Layout = () => {
  const {helpPlace} = useRegistrationView()
  return (
    <div
      className='mp-register-layout d-flex flex-column flex-lg-row flex-column-fluid'
      style={{minHeight: '100%'}}
    >
      {/* begin::Body */}
      <div className='mp-register-layout__body d-flex flex-column flex-lg-row-fluid w-100 p-4 p-md-8 p-xl-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-100 p-1'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div
        className='d-flex flex-lg-row-fluid w-lg-25 bgi-size-cover bgi-position-center order-1 order-lg-2 d-none d-xl-block'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`,
          backgroundPosition: 'top',
          backgroundSize: 'inherit',
        }}
      >
        {/* begin::Content */}
        <div className='d-flex flex-column flex-top py-5 px-5 px-md-5 w-100 text-center'>
          {/* begin::Logo */}
          <Link to='/' className='mb-12'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/default-dark.svg')}
              className='h-75px'
            />
          </Link>
          {/* end::Logo */}
          <div style={{whiteSpace: 'pre-line'}} className='p-5'>
            {helpPlace}
          </div>
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  )
}
const RegisterLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <RegisterationProvider>
      <Layout />
    </RegisterationProvider>
  )
}

export {RegisterLayout}
